<template>
    <div>
        <template v-if="dataType == 1">
            <div class="title">{{ detail.title }}</div>
            <table v-for="item, key, i in detail.data" :key="i">
                <thead>
                    <tr>
                        <td v-if="key != undefined">{{ key }}</td>
                        <td class="team-name">球队</td>
                        <td>场次</td>
                        <td>胜</td>
                        <td>平</td>
                        <td>负</td>
                        <td>进球</td>
                        <td>失球</td>
                        <td>净胜球</td>
                        <td>积分</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="teamItem, y in item" :key="y" :class="{ 'active': y < (keys.length > 1 ? 2 : 3) }">
                        <td>{{ teamItem.ranking }}</td>
                        <td class="team-name">
                            <img :src="teamItem.team_logo" alt="">
                            {{ teamItem.team_name }}
                        </td>
                        <td>{{ teamItem.total_count }}</td>
                        <td>{{ teamItem.win_count }}</td>
                        <td>{{ teamItem.draw_count }}</td>
                        <td>{{ teamItem.lose_count }}</td>
                        <td>{{ teamItem.get_score }}</td>
                        <td>{{ teamItem.lose_score }}</td>
                        <td>{{ teamItem.get_score - teamItem.lose_score }}</td>
                        <td>{{ teamItem.integral }}</td>
                    </tr>
                </tbody>
            </table>
        </template>
        <template v-else-if="dataType == 2">
            <div class="title">{{ detail.title }}</div>
            <table v-for="item, key, i in detail.data" :key="i">
                <thead>
                    <tr>
                        <td>排行</td>
                        <td>{{ key }}</td>
                        <td>胜</td>
                        <td>负</td>
                        <td>胜率</td>
                        <td>胜场差</td>
                        <td>近况</td>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="teamItem, y in item" :key="y" :class="{ 'active': teamItem.ranking <= 8 }">
                        <td>{{ teamItem.ranking }}</td>
                        <td>{{ teamItem.team_name }}</td>
                        <td>{{ teamItem.win_count }}</td>
                        <td>{{ teamItem.lose_count }}</td>
                        <td>{{ teamItem.win_rate }}%</td>
                        <td>{{ (item[0].win_count - teamItem.win_count) - ((item[0].total_count - teamItem.total_count)/2) }}</td>
                        <td>{{
            teamItem.state > 0
                ? teamItem.state + "连胜"
                : Math.abs(teamItem.state) + "连败"
        }}</td>
                    </tr>
                </tbody>
            </table>
        </template>
    </div>
</template>

<script>

import axios from "axios";
export default {
    data() {
        return {
        }
    },
    props: {
        detail: {

        },
        dataType: {
            default: '1'
        }
    },
    computed: {
        keys() {
            return Object.keys(this.detail.data);
        }
    },
}
</script>

<style lang="less" scoped>
.title {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #fff;
    background: #e24949;
    font-size: 18px;
}

thead tr {
    border: none;
}

table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    margin-bottom: 20px;

    thead {
        width: 100%;

        tr {
            background: #F7EFE4;
            color: #333;
            height: 48px;
            line-height: 48px;
            border-bottom: 1px solid #ededed;
            text-align: center;
        }
    }

    tbody {
        width: 100%;

        tr {
            background: #f7f7f7;
            color: #333;
            height: 60px;
            line-height: 60px;
            border-bottom: 1px solid #e7f7eb;
            text-align: center;
        }
    }

    .team-name {
        width: 240px;
        text-align: left;
        padding-left: 20px;

        img {
            width: 30px;
            height: 30px;
            margin: 0 10px 0 0;
            position: relative;
            bottom: -10px;
        }
    }

    .nodata {
        width: 940px;
        text-align: center;
        height: 400px;
        line-height: 400px;
        color: #999;
    }

    .active {
        background: #f5dcde;
    }

}
</style>
